import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { bindActionCreators } from 'redux';

import MenuHeader from './MenuHeader';
import MenuBody from './MenuBody';

import * as bookActions from '../../../actions/bookActions';
import * as classroomActions from '../../../actions/classroom/classroomActions';

class CustomMenu extends React.Component {
  static propTypes = {
    route: PropTypes.string,
    bookActions: PropTypes.object,
    classroomActions: PropTypes.object,
    inClassroom: PropTypes.any
  };

  componentDidMount() {
    this.setAppRoute();
  }

  componentDidUpdate(prevProps) {
    const { route } = this.props;
    if (!_.isEqual(route, prevProps.route)) this.setAppRoute();
  }

  setAppRoute() {
    const { bookActions, classroomActions, inClassroom } = this.props;
    if (!inClassroom) {
      bookActions.setBooksData();
      classroomActions.setClassroomInfo();
    }
  }

  render() {
    const { inClassroom } = this.props;

    return (
      <div>
        <MenuHeader inClassroom={inClassroom} />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomMenu);

function mapStateToProps(state) {
  return {
    inClassroom: state.router.inClassroom
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    classroomActions: bindActionCreators(classroomActions, dispatch)
  };
}
